<h1>{{'matching-products.matching-products' | i18next}}</h1>
<div class="product-list  grid grid-gap-big">
  <ng-container *ngFor='let product of crossSellingProducts'>
    <div *ngIf="product"
         [routerLink]="['/collections/collection-detail/' + product.collection +'/product/'+ product.sku]"
         class="xs-6 m-3 product-card">
      <img loading="lazy" src="{{ product.images.freestanding_1 | image }}">
      <div class="product-info-box">
        <h2 [innerHTML]="product.texts.caption | i18next"></h2>
        <div *ngIf="priceActive" class="price">
          <span class="line"></span>
          {{product.price | currency: collectionsService.currencyCode:  currencySymbol:'1.2-2': 'de' }}
        </div>
        <small class="ean text-right">{{ product.sku | skuFormatter }}</small>
      </div>
    </div>
  </ng-container>
</div>
